import styled from "styled-components";

const PilarContainer = styled.div`
  display: flex;
  padding: 15px 15px 30px 15px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 25px;
  background: ${(props) => props.theme.colors.primary.contrast};
  max-width: 411px;
  min-width: 230px;
  position: relative;
  height: 575px;

  .pilar-image {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    width: 100%;
    max-width: 100%;
    height: auto;
    border-radius: 11px;
  }

  .pilar-title {
    color: ${(props) => props.theme.colors.primary.darkShadeOfGray};
    text-align: center;
    font-family: Mulish;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    min-height: 60px;
    align-self: stretch;
    margin: 0;
    padding: 0;
    white-space: pre-line;
  }

  .pilar-description {
    color: ${(props) => props.theme.colors.primary.darkShadeOfGray};
    text-align: center;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
    margin: 0;
  }

  .pilar-button {
    position: absolute;
    bottom: 30px;
  }

  @media screen and (max-width: 1024px) {
    width: 360px;
    margin-bottom: 20px;
    .pilar-button {
      position: static;
    }
  }
  @media screen and (max-width: 390px) {
    width: 100%;
  }
`;

export default PilarContainer;
